import intlTelInput from 'intl-tel-input'

$(function () {
    const input = document.querySelector(".intl-tel-input");
    intlTelInput(input, {
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js",
        initialCountry: input.dataset.countryCode,
        separateDialCode: true,
        formatOnDisplay: true,
        autoPlaceholder: "aggressive",
        autoInsertDialCode: true,
    });
})


